import { render, staticRenderFns } from "./CourseEffects.vue?vue&type=template&id=e6f0ad38&scoped=true&"
import script from "./CourseEffects.vue?vue&type=script&lang=js&"
export * from "./CourseEffects.vue?vue&type=script&lang=js&"
import style0 from "./CourseEffects.vue?vue&type=style&index=0&id=e6f0ad38&scoped=true&lang=scss&"
import style1 from "./CourseEffects.vue?vue&type=style&index=1&id=e6f0ad38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f0ad38",
  null
  
)

export default component.exports